<template>
    <div class="flex flex-col items-center">
        A Generic Choose-Multiple Question

        <div class="flex my-4">
            <label class="flex items-center mx-4">
                <input class="mr-2"
                    type="checkbox"
                    v-model="value"
                    value="a"
                >

                <p class="pb-0">Choice A</p>
            </label>

            <label class="flex items-center mx-4">
                <input class="mr-2"
                    type="checkbox"
                    v-model="value"
                    value="b"
                >

                <p class="pb-0">Choice B</p>
            </label>

            <label class="flex items-center mx-4">
                <input class="mr-2"
                    type="checkbox"
                    v-model="value"
                    value="c"
                >

                <p class="pb-0">Choice C</p>
            </label>
        </div>

        <div class="flex my-4">
            <button class="mx-2" @click="answer">
                Submit
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {},
    },

    data() {
        return {
            value: [],
        }
    },

    methods: {
        answer() {
            this.$emit('answered', this.value);
        }
    },
}
</script>
